The schema's entry-point for mutations.

This acts as the public, top-level API from which all mutation queries must start.
